// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__Zd2Ou","amount":"Amount_amount__BiZ50","tip":"Amount_tip__2GYZd","tipHeader":"Amount_tipHeader__12qTq","tipsWrap":"Amount_tipsWrap__28pd-"};